import { useEffect, useState, FormEvent, useContext } from "react";
import { getTokenForWeb, userLoginOps } from "../../services/auth";
import { decrypt, encrypt, validUserLogin } from "../../utils/Util";
import { IUserLogin } from "../../models/IUserLogin";
import { Context } from "../../utils/AppContext";
import { useNavigate } from "react-router-dom";
import "../rentaroomstyle.css";

const getOrCreateDeviceId = (): string => {
  const stored = localStorage.getItem("deviceId");
  if (stored) return stored;
  const newId = crypto.randomUUID();
  localStorage.setItem("deviceId", newId);
  return newId;
};

function RentARoomLogin() {
  const navigate = useNavigate();
  const context = useContext(Context);

  const hasSaved = !!(localStorage.username && localStorage.password);
  const [remember, setRemember] = useState(hasSaved);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const [userdata, setUserdata] = useState<IUserLogin>({
    email: localStorage.username ? decrypt(localStorage.username) : "",
    password: localStorage.password ? decrypt(localStorage.password) : "",
    deviceId: getOrCreateDeviceId(),
  });

  useEffect(() => {
    getTokenForWeb()
      .then((res) => {
        if (res?.data) localStorage.setItem("MA", encrypt(JSON.stringify(res.data)));
      })
      .catch((err) => console.log("error", err.message));
  }, []);

  const userLogin = (evt: FormEvent) => {
    evt.preventDefault();
    if (!validUserLogin(userdata.email, userdata.password)) return;

    if (remember) {
      localStorage.setItem("username", encrypt(userdata.email));
      localStorage.setItem("password", encrypt(userdata.password));
    } else {
      localStorage.removeItem("username");
      localStorage.removeItem("password");
    }

    setLoading(true);
    userLoginOps(userdata)
      .then((res) => {
        const dt = res.data;
        localStorage.setItem("user", encrypt(JSON.stringify(dt)));
        context.setName(dt);
        navigate("/rentaroom/dashboard", { replace: true });
      })
      .catch((err) => {
        const data = err?.response?.data;
        const apiMsg = Array.isArray(data) && data[0]?.description
          ? data[0].description
          : err.message;
        setErrorMessage(apiMsg);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="rar-login-bg">
      <div className="rar-login-card">
        {/* Logo */}
        <div className="text-center mb-4">
          <div className="rar-login-icon">
            <i className="bi bi-building text-white" style={{ fontSize: "1.6rem" }}></i>
          </div>
          <h4 className="fw-bold mb-1 rar-login-title">RentARoom Admin</h4>
          <p className="text-muted small mb-0">Hesabınıza giriş yapın</p>
        </div>

        {/* Hata */}
        {errorMessage && (
          <div className="rar-login-error">
            <i className="bi bi-exclamation-circle-fill flex-shrink-0"></i>
            <span>{errorMessage}</span>
            <button className="rar-login-error-close" onClick={() => setErrorMessage("")}>
              <i className="bi bi-x-lg"></i>
            </button>
          </div>
        )}

        <form onSubmit={userLogin}>
          {/* Email */}
          <div className="mb-3">
            <label className="form-label small fw-semibold mb-1" style={{ color: "#374151" }}>
              E-posta
            </label>
            <div className="input-group">
              <span className="input-group-text rar-login-input-icon">
                <i className="bi bi-envelope-fill"></i>
              </span>
              <input
                type="email"
                value={userdata.email}
                onChange={(e) => setUserdata({ ...userdata, email: e.target.value })}
                className="form-control rar-login-input"
                placeholder="ornek@email.com"
                required
              />
            </div>
          </div>

          {/* Şifre */}
          <div className="mb-3">
            <label className="form-label small fw-semibold mb-1" style={{ color: "#374151" }}>
              Şifre
            </label>
            <div className="input-group">
              <span className="input-group-text rar-login-input-icon">
                <i className="bi bi-lock-fill"></i>
              </span>
              <input
                type={showPass ? "text" : "password"}
                value={userdata.password}
                onChange={(e) => setUserdata({ ...userdata, password: e.target.value })}
                className="form-control rar-login-input with-toggle"
                placeholder="••••••••"
                required
              />
              <button
                type="button"
                className="input-group-text rar-login-toggle-btn"
                onClick={() => setShowPass(!showPass)}
              >
                <i className={`bi ${showPass ? "bi-eye-slash-fill" : "bi-eye-fill"}`}></i>
              </button>
            </div>
          </div>

          {/* Beni Hatırla */}
          <div className="d-flex align-items-center mb-4">
            <div
              className="rar-login-remember-box"
              onClick={() => setRemember(!remember)}
              style={{
                border: `2px solid ${remember ? "#3b82f6" : "#d1d5db"}`,
                background: remember ? "#3b82f6" : "#fff",
              }}
            >
              {remember && <i className="bi bi-check text-white" style={{ fontSize: "0.7rem", lineHeight: 1 }}></i>}
            </div>
            <label
              onClick={() => setRemember(!remember)}
              className="ms-2 small"
              style={{ color: "#6b7280", cursor: "pointer", userSelect: "none" }}
            >
              Beni hatırla
            </label>
          </div>

          {/* Giriş Butonu */}
          <button
            type="submit"
            className="btn rar-login-submit-btn"
            disabled={loading}
            style={{
              background: loading
                ? "#93c5fd"
                : "linear-gradient(135deg, #3b82f6, #1d4ed8)",
            }}
          >
            {loading ? (
              <><span className="spinner-border spinner-border-sm me-2" role="status"></span>Giriş yapılıyor...</>
            ) : (
              <><i className="bi bi-box-arrow-in-right me-2"></i>Giriş Yap</>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}

export default RentARoomLogin;
